var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCareerflowLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.355 23.6673C12.834 23.8475 10.0113 22.5979 8.20056 19.597C6.40601 16.6226 6.48419 13.5314 8.42012 10.6405C10.2426 7.92006 12.9207 6.7487 16.2027 6.92525C12.548 8.57023 10.3941 11.2914 10.4253 15.3453C10.4569 19.395 12.6562 22.0743 16.3546 23.6669L16.355 23.6673Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9829 12.0287C12.1466 11.5244 12.4034 11.0774 12.6951 10.6502C13.6187 9.297 14.8526 8.31549 16.3474 7.65242C16.7545 7.47184 17.1835 7.3497 17.6129 7.2316C17.7546 7.1925 17.8944 7.20862 18.0317 7.25135C19.3511 7.66129 20.5101 8.34653 21.4847 9.31796C21.9951 9.82705 22.19 10.4611 21.9619 11.1709C21.7322 11.8844 21.2311 12.3125 20.4939 12.4636C19.7874 12.6083 19.213 12.3471 18.7074 11.8808C17.747 10.9952 16.6119 10.5425 15.303 10.5756C14.057 10.6066 12.9806 11.0698 12.0834 11.9364C12.0506 11.9682 12.0165 11.9989 11.9829 12.0299V12.0287Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9037 18.3845C12.2087 18.7227 12.5531 18.9968 12.9306 19.2326C14.5335 20.2334 16.7077 20.1476 18.232 19.0242C18.3945 18.9045 18.55 18.7771 18.7072 18.6509C19.6827 17.8645 21.2961 18.3664 21.698 19.5776C21.9597 20.3665 21.764 21.036 21.1386 21.5894C20.2421 22.3827 19.216 22.9422 18.083 23.3182C17.8873 23.3831 17.6941 23.3948 17.4883 23.336C14.9062 22.5995 13.0627 21.011 11.9402 18.5881C11.9142 18.5324 11.8656 18.4752 11.9037 18.3849V18.3845Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareerflowLogo);
export default __webpack_public_path__ + "static/media/careerflowLogo.4ad8ff31763af32916023c5e6aa46b71.svg";
export { ForwardRef as ReactComponent };